{
  "countries": {
    "AF": "Afganistán",
    "AX": "Islas Åland",
    "AL": "Albania",
    "DZ": "Argelia",
    "AS": "Samoa Americana",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguila",
    "AQ": "Antártida",
    "AG": "Antigua y Barbuda",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AC": "Isla de la Ascensión",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaiyán",
    "BS": "Bahamas",
    "BH": "Baréin",
    "BD": "Bangladés",
    "BB": "Barbados",
    "BY": "Bielorrusia",
    "BE": "Bélgica",
    "BZ": "Belice",
    "BJ": "Benín",
    "BM": "Bermudas",
    "BT": "Bután",
    "BO": "Bolivia",
    "BA": "Bosnia y Herzegovina",
    "BW": "Botsuana",
    "BR": "Brasil",
    "IO": "Territorio Británico del Océano Índico",
    "VG": "Islas Vírgenes Británicas",
    "BN": "Brunéi",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Camboya",
    "CM": "Camerún",
    "CA": "Canadá",
    "IC": "Islas Canarias",
    "CV": "Cabo Verde",
    "BQ": "Caribe Neerlandés",
    "KY": "Islas Caimán",
    "CF": "República Centroafricana",
    "EA": "Ceuta y Melilla",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "China",
    "CX": "Isla de Navidad",
    "CC": "Islas Cocos (Keeling)",
    "CO": "Colombia",
    "KM": "Comoras",
    "CG": "Congo - Brazzaville",
    "CD": "Congo - Kinshasa",
    "CK": "Islas Cook",
    "CR": "Costa Rica",
    "CI": "Côte d’Ivoire",
    "HR": "Croacia",
    "CU": "Cuba",
    "CW": "Curazao",
    "CY": "Chipre",
    "CZ": "Chequia",
    "DK": "Dinamarca",
    "DG": "Diego García",
    "DJ": "Yibuti",
    "DM": "Dominica",
    "DO": "República Dominicana",
    "EC": "Ecuador",
    "EG": "Egipto",
    "SV": "El Salvador",
    "GQ": "Guinea Ecuatorial",
    "ER": "Eritrea",
    "EE": "Estonia",
    "SZ": "Esuatini",
    "ET": "Etiopía",
    "FK": "Islas Malvinas",
    "FO": "Islas Feroe",
    "FJ": "Fiyi",
    "FI": "Finlandia",
    "FR": "Francia",
    "GF": "Guayana Francesa",
    "PF": "Polinesia Francesa",
    "TF": "Territorios Australes Franceses",
    "GA": "Gabón",
    "GM": "Gambia",
    "GE": "Georgia",
    "DE": "Alemania",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Grecia",
    "GL": "Groenlandia",
    "GD": "Granada",
    "GP": "Guadalupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GG": "Guernsey",
    "GN": "Guinea",
    "GW": "Guinea-Bisáu",
    "GY": "Guyana",
    "HT": "Haití",
    "HN": "Honduras",
    "HK": "RAE de Hong Kong (China)",
    "HU": "Hungría",
    "IS": "Islandia",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Irán",
    "IQ": "Irak",
    "IE": "Irlanda",
    "IM": "Isla de Man",
    "IL": "Israel",
    "IT": "Italia",
    "JM": "Jamaica",
    "JP": "Japón",
    "JE": "Jersey",
    "JO": "Jordania",
    "KZ": "Kazajistán",
    "KE": "Kenia",
    "KI": "Kiribati",
    "XK": "Kosovo",
    "KW": "Kuwait",
    "KG": "Kirguistán",
    "LA": "Laos",
    "LV": "Letonia",
    "LB": "Líbano",
    "LS": "Lesoto",
    "LR": "Liberia",
    "LY": "Libia",
    "LI": "Liechtenstein",
    "LT": "Lituania",
    "LU": "Luxemburgo",
    "MO": "RAE de Macao (China)",
    "MG": "Madagascar",
    "MW": "Malaui",
    "MY": "Malasia",
    "MV": "Maldivas",
    "ML": "Malí",
    "MT": "Malta",
    "MH": "Islas Marshall",
    "MQ": "Martinica",
    "MR": "Mauritania",
    "MU": "Mauricio",
    "YT": "Mayotte",
    "MX": "México",
    "FM": "Micronesia",
    "MD": "Moldavia",
    "MC": "Mónaco",
    "MN": "Mongolia",
    "ME": "Montenegro",
    "MS": "Montserrat",
    "MA": "Marruecos",
    "MZ": "Mozambique",
    "MM": "Myanmar (Birmania)",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "Países Bajos",
    "NC": "Nueva Caledonia",
    "NZ": "Nueva Zelanda",
    "NI": "Nicaragua",
    "NE": "Níger",
    "NG": "Nigeria",
    "NU": "Niue",
    "NF": "Isla Norfolk",
    "KP": "Corea del Norte",
    "MK": "Macedonia del Norte",
    "MP": "Islas Marianas del Norte",
    "NO": "Noruega",
    "OM": "Omán",
    "PK": "Pakistán",
    "PW": "Palaos",
    "PS": "Territorios Palestinos",
    "PA": "Panamá",
    "PG": "Papúa Nueva Guinea",
    "PY": "Paraguay",
    "PE": "Perú",
    "PH": "Filipinas",
    "PN": "Islas Pitcairn",
    "PL": "Polonia",
    "PT": "Portugal",
    "XA": "Pseudo-Accents",
    "XB": "Pseudo-Bidi",
    "PR": "Puerto Rico",
    "QA": "Catar",
    "RE": "Reunión",
    "RO": "Rumanía",
    "RU": "Rusia",
    "RW": "Ruanda",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "Santo Tomé y Príncipe",
    "SA": "Arabia Saudí",
    "SN": "Senegal",
    "RS": "Serbia",
    "SC": "Seychelles",
    "SL": "Sierra Leona",
    "SG": "Singapur",
    "SX": "Sint Maarten",
    "SK": "Eslovaquia",
    "SI": "Eslovenia",
    "SB": "Islas Salomón",
    "SO": "Somalia",
    "ZA": "Sudáfrica",
    "GS": "Islas Georgias del Sur y Sandwich del Sur",
    "KR": "Corea del Sur",
    "SS": "Sudán del Sur",
    "ES": "España",
    "LK": "Sri Lanka",
    "BL": "San Bartolomé",
    "SH": "Santa Elena",
    "KN": "San Cristóbal y Nieves",
    "LC": "Santa Lucía",
    "MF": "San Martín",
    "PM": "San Pedro y Miquelón",
    "VC": "San Vicente y las Granadinas",
    "SD": "Sudán",
    "SR": "Surinam",
    "SJ": "Svalbard y Jan Mayen",
    "SE": "Suecia",
    "CH": "Suiza",
    "SY": "Siria",
    "TW": "Taiwán",
    "TJ": "Tayikistán",
    "TZ": "Tanzania",
    "TH": "Tailandia",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad y Tobago",
    "TA": "Tristán de Acuña",
    "TN": "Túnez",
    "TR": "Turquía",
    "TM": "Turkmenistán",
    "TC": "Islas Turcas y Caicos",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ucrania",
    "AE": "Emiratos Árabes Unidos",
    "GB": "Reino Unido",
    "US": "Estados Unidos",
    "UY": "Uruguay",
    "UM": "Islas menores alejadas de EE. UU.",
    "VI": "Islas Vírgenes de EE. UU.",
    "UZ": "Uzbekistán",
    "VU": "Vanuatu",
    "VA": "Ciudad del Vaticano",
    "VE": "Venezuela",
    "VN": "Vietnam",
    "WF": "Wallis y Futuna",
    "EH": "Sáhara Occidental",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabue"
  }
}
